import { render } from "./spend.vue?vue&type=template&id=95fed076&scoped=true"
import script from "./spend.vue?vue&type=script&lang=js"
export * from "./spend.vue?vue&type=script&lang=js"

import "./spend.vue?vue&type=style&index=0&id=95fed076&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95fed076"]])

export default __exports__